import React from "react";
import styles from "./HeroSection.module.css";

export default function HeroSection() {
  return (
    <div className={styles.hero}>
      <div className={styles["hero-content"]}>
        <h1>Hi, I'm John. I build cross-platform mobile apps.</h1>
        <p>React Native · Android · iOS · Flutter · AWS</p>
        <div className={styles["hero-buttons"]}>
          <a
            href="#projects"
            className={styles["btn-primary"]}
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            View My Work
          </a>
          <a
            href="#contact"
            className={styles["btn-secondary"]}
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            Get in Touch
          </a>
        </div>
      </div>
      <div className={styles["hero-image"]}>
        <img
          src="/hero.png"
          alt="App screens on phones"
          style={{
            width: "100%",
            borderRadius: "1.5rem",
          }}
        />
      </div>
    </div>
  );
}
